import { Button, Card, CardContent, CardHeader, Divider } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const useStyles = makeStyles(theme => ({
  root: {},
  mainActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  notice: {
    marginTop: theme.spacing(1)
  },
  deleteButton: {
    marginTop: theme.spacing(1),
    color: theme.palette.white,
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.dark
    }
  },
  closeButton: {
    marginTop: theme.spacing(1),
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  }
}));
const OtherActions = props => {
  const { className, handleDelete, ...rest } = props;
  const [deleteState, setDeleteState] = useState(false);
  const classes = useStyles();

  const handleDeleteConfirm = () => {
    if (deleteState) return handleDelete();
    setDeleteState(!deleteState);
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Other actions" />
      <Divider />
      <CardContent>
        {deleteState &&
          <Button fullWidth className={classes.closeButton} onClick={() => setDeleteState(false)}>
            <CloseIcon className={classes.buttonIcon} />
            Cancel
        </Button>}
        <Button fullWidth className={classes.deleteButton} onClick={handleDeleteConfirm}>
          <DeleteIcon className={classes.buttonIcon} />
          {deleteState ? "Confirm" : "Delete Lesson"}
        </Button>
      </CardContent>
    </Card>
  );
};

OtherActions.propTypes = {
  className: PropTypes.string
};

export default OtherActions;
